import React, { useMemo } from 'react';

import { getSearchEntryError, isBooleanSearch } from 'helpers/booleanValidator';

import { Box } from 'rebass/styled-components';
import isEqual from 'lodash.isequal';

export const useOptions = ({ searchText, useSearchAsTag, loading, isMulti, menuOptions, selected }) => {
  const filteredOptions = useMemo(
    () =>
      isMulti
        ? menuOptions.filter(
            (option) => !selected?.some?.((selectedOption) => isEqual(selectedOption.value, option.value)),
          )
        : menuOptions,
    [isMulti, menuOptions, selected],
  );

  const isBoolean = isBooleanSearch(searchText);
  // Judge and commit the same string Enter would, so the two paths agree.
  const trimmedSearch = (searchText || '').trim();
  // Keep the add-as-tag option out of the list for entries Enter would reject,
  // so clicking it can't commit what the keyboard path blocks — including the
  // empty string, which Enter bails on before it ever reaches validation.
  const canTagSearch = Boolean(trimmedSearch) && !getSearchEntryError(trimmedSearch);

  const options = useMemo(() => {
    const searchAsTag = {
      label: trimmedSearch,
      children: (
        <>
          Press ‘enter’ to add{' '}
          <Box as="span" color="inherit" fontWeight="500">
            {searchText}
          </Box>
        </>
      ),
      value: trimmedSearch,
    };

    if (isBoolean && useSearchAsTag) {
      return canTagSearch ? [searchAsTag] : [];
    }

    if (useSearchAsTag) {
      return [...(canTagSearch ? [searchAsTag] : []), ...(loading ? [] : filteredOptions)];
    }

    return [...filteredOptions];
  }, [canTagSearch, filteredOptions, isBoolean, loading, searchText, trimmedSearch, useSearchAsTag]);

  return {
    options,
    isBoolean,
  };
};
